export const pageSizes = [5, 10, 15]; 
export const defaultPageIndex = 0;
export const defaultPageSize = 10;

export const defaultExportFormats = ['xlsx', 'csv', 'pdf'];
export const noPDFexportFormats = ['xlsx', 'csv'];
export const noCSVexportFormats = ['xlsx', 'pdf'];
export const onlyXLSXexport = ['xlsx'];
export const noExportOption = [];

export const defaultDateFormat = 'dd/MM/yyyy HH:mm:ss'
export const shortDateFormat = 'dd/MM/yyyy';

export const EMPTY_PANEL_TEXT = ' ';
